module.exports = __webpack_public_path__ + "img/Verona.c23bac9b.svg";